/*
 * Query Middleware
 * - Middleware to add .query property support  to redux-api-request
 * note: must be composed before redux-api-middleware
 */

import qs from 'querystring';
import { API_REQUEST } from 'redux-api-request/dist/action_types'

export default function queryMiddleware() {
  return next => action => {
    if (action.type === API_REQUEST && action.hasOwnProperty('query') && action.query !== undefined) {
      if(null !== action.query) {
        // add query to endpoint
        action.endpoint = [
          action.endpoint.replace(/\?*/, ''),
          qs.stringify(action.query),
        ].join('?');
      }

      delete action.query;

    }

    return next(action);
  };
}


// WEBPACK FOOTER //
// ./src/utils/query.middleware.js